import React from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Link } from "react-router-dom";

const BackHeader = ({ backButton, link, title, rightSide, leftSide,backHeaderClass, backHeaderTitleClass }) => {
  return (
    <div className="flex justify-between items-center gap-2 md:gap-5 w-full">
      <div className={`${backHeaderClass} flex  items-center gap-2 md:gap-5 `}>
        {backButton === true && (
          <Link to={link}>
            <div className= "flex items-center justify-center border border-slate-300 rounded-md w-6 h-6 md:w-8 md:h-8 cursor-pointer">
              <IoMdArrowRoundBack className="text-slate-500 text-xs md:text-base" />
            </div>
          </Link>
        )}
        {leftSide && (
          <div
            className="flex items-center justify-center border border-slate-300 rounded-md w-6 h-6 md:w-8 md:h-8 cursor-pointer"
            onClick={leftSide}
          >
            <IoMdArrowRoundBack className="text-slate-500 text-xs md:text-lg" />
          </div>
        )}
        <h2 className={`${backHeaderTitleClass ? backHeaderTitleClass : "text-slate-500" } capitalize text-lg md:text-2xl text-center font-bold`}>
          {title}
        </h2>
      </div>
      {rightSide}
    </div>
  );
};

export default BackHeader;
